import axios from 'axios'
import backendUrl from '../configback'

const local = `${backendUrl}`
const api = axios.create({
    baseURL: `${local}/api`,
    withCredentials: true
})

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('customerToken');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
})

export default api